/* TD 2026-10-11 UX-PDP #1 — the value chip in a step title ("2. Größe: 135 x 200 cm", snippets/td-variant-picker.liquid)
   follows a tap at once; the theme re-renders the picker from the server a moment later with the same text. Loaded by
   sections/main-product.liquid (defer). One delegated listener, nothing else. */
(function () {
  'use strict';
  if (window.tdUxPdp) return;
  window.tdUxPdp = true;
  document.addEventListener('change', function (e) {
    var input = e.target;
    if (!input || !input.matches || !input.matches('[data-td-variant-picker] input[data-option-position]') || !input.checked) return;
    var fieldset = input.closest('fieldset');
    var chip = fieldset && fieldset.querySelector('[data-td-option-selected-value]');
    var value = input.getAttribute('data-option-value');
    if (chip && value && chip.textContent !== value) chip.textContent = value;
  });
})();
